<template>
  <div>
    <SimulacaoFinalizar ref="finalizar" :value="model" @close="close" @salvar="salvar" />
    <resumo-padrao ref="resumo" :vlr-registro="vlrRegistro"></resumo-padrao>
  </div>
</template>
<script>
export default {
  components: {
    SimulacaoFinalizar: () => import('./SimulacaoFinalizar.vue'),
  },
  props: {
    value: null,
  },
  data () {
    return {
      model: {},
      IOF_NOTA: 0.001,
    };
  },
  computed: {
    vlrRegistro () {
      return this.mValue.GarantiaSimulacao?.reduce((acc, obj) => acc + obj.VlrRegistro, 0);
    },
    isentaIOF () {
      return this.$api.Estruturadas.isNotaComercial(this.mValue.TipoContratoSigla) || this.mValue.IsentarIOF
    },
    simulaComIndexador () {
      return this.$param.SimulaComIndexador
    },
    mValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
  },
  methods: {
    submit (callback) {
      const th = this

      if (th.mValue.TipoCalculoFluxo === th.$aux.TipoFluxoEnum.Irregular) {
        delete th.model.Codigo

        th.model = {
          ...this.model,
          ...this.mValue,
        }
        this.$emit('input', th.model)
        this.$refs.finalizar.openModal()
      } else {
        this.$refs.finalizar.openModal()
      }
    },
    close (response) {
      if (response) { this.$emit('close', response) }
    },
    salvar (callback) {
      const th = this;

      var dto = th.mValue;
      dto = {
        ...dto,
        ...th.model,
        Chave: th.mValue.DocumentoFederal,
        Nome: th.mValue.Nome,
        Descricao: '',
        ModelJson: JSON.stringify(th.mValue),
        DtExpiracao: th.mValue.DtEmissao,
      };
      th.$api.Simulacao.Persist(dto, 'Codigo').then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          if (response.codigo) {
            th.model.Codigo = response.codigo
            th.model.CodigoUsuario = response.codigoUsuario
            th.model.CodigoEmpresa = response.codigoEmpresa
          }
          callback(th.model.Codigo)
        }
      })
    },
    async load () {
      const th = this;
      if (th.mValue.TipoCalculoFluxo === th.$aux.TipoFluxoEnum.Irregular) {
        if (th.isentaIOF) th.mValue.dtoFluxoIrregular.IsentarIOF = true
        const { PMTIrregular } = await th.$api.Estruturadas.CalcularFluxoIrregular(th, th.mValue.dtoFluxoIrregular)
        PMTIrregular.Parcelas && PMTIrregular.Parcelas.forEach((item) => {
          item.DtVencimento = item.DtVencimento.split('T')[0]
        })
        th.setModel({ Proposta: PMTIrregular })

        th.mValue.CodigoSimulacao = PMTIrregular.CodigoSimulacao

        return
      }
      const tipoPessoa = th.$api.UI.Format.SomenteAlfanumerico(th.mValue.DocumentoFederal).length === 11 ? 1 : 2

      th.mValue.CodigoOperacao = th.$api.UI.Guid.New();
      var vlrSolicitado = th.mValue.TipoOperacaoCred === 3 ? (th.mValue.VlrProdutoBem - th.mValue.VlrEntrada) : th.mValue.VlrSolicitado
      vlrSolicitado += th.mValue.ModeloCalculo === th.$aux.ModeloCalculoEnum.SAC ? (th.mValue.VlrITBI + th.mValue.VlrRegistroImovel + th.mValue.VlrRegistroGarantia) : 0

      const obj = {
        dto: {
          Prazo: th.mValue.Prazo,
          VlrSeguro: (th.mValue.VlrSeguro || 0),
          VlrAvaliacao: (th.mValue.VlrAvaliacao || 0),
          VlrVistoria: (th.mValue.VlrVistoria || 0),
          TipoPessoa: tipoPessoa,
          NroDiasAcrescimo: th.$api.UI.Date.DaysBetween(th.$api.UI.Date.AddMonth(new Date(), 1), th.mValue.DtPrimeiroVencto),
          VlrSolicitado: vlrSolicitado,
          VlrTAC: th.mValue.VlrTAC,
          PercJurosNegociado: th.mValue.TipoContratoSigla === 'FI' ? th.$api.Estruturadas.JurosAnualParaMensal(th.mValue.TxJuros) : th.mValue.TxJuros,
          VlrOutrosServicos: th.vlrRegistro
        },
        parametros: []
      };

      if (this.mValue.TipoOperacaoCred === 3) {
        obj.dto.VlrEntrada = th.mValue.VlrEntrada || 0
        obj.dto.VlrProdutoBem = th.mValue.VlrProdutoBem || 0
      }

      if (th.mValue.ModeloCalculo === th.$aux.ModeloCalculoEnum.SAC) {
        if (th.mValue.TipoIndexador === 2) {
          obj.dto.TipoIndiceFinanceiro = th.mValue.TipoIndiceFinan
          obj.dto.PercIndiceFinanceiro = th.mValue.PercIndiceFinan
        }
        obj.dto.VlrTxAdmMensal = th.mValue.VlrTxAdmMensal
        obj.dto.PercSeguroMensal1 = th.mValue.PercSeguroMensal1
        obj.dto.PercSeguroMensal2 = th.mValue.PercSeguroMensal2
        obj.dto.VlrSeguroMensal1 = th.mValue.VlrSeguroMensal1
        obj.dto.VlrSeguroMensal2 = th.mValue.VlrSeguroMensal2
      }

      if (th.isentaIOF) {
        obj.parametros.push({ Nome: 'PROPOSTA_ISENTARIOF', Valor: true })
        obj.dto.VlrIOF = th.IOF_NOTA
      }

      if (th.simulaComIndexador) {
        obj.dto.IncluirCorrecaoPos = true
      }

      if (th.mValue.ModeloCalculo === th.$aux.ModeloCalculoEnum.SAC) {
        th.$api.Multiplo.Post('CalculaGridParcelasSimplificadoSAC', obj).then(
          (result) => {
            th.setModel(result)
          }
        );
      } else {
        th.$api.Multiplo.Post('CalculaGridParcelasSimplificadoPrice', obj).then(
          (result) => {
            th.setModel(result)
          }
        );
      }
    },
    async setModel (result) {
      const th = this
      var proposta = {
        ...th.mValue,
        ...result.Proposta
      }
      const totalCredito = Math.round(proposta.VlrTotalCredito * 100) / 100

      if (th.$api.Estruturadas.isNotaComercial(th.mValue.TipoContratoSigla) && !Number.isInteger(totalCredito)) {
        th.model = proposta
        await th.$api.Estruturadas.RoundNotaComercial(th, null, true)
        proposta.VlrTAC = th.model.VlrTAC
      }

      let valorSolicitado = proposta.TipoOperacaoCred === 3 ? (proposta.VlrProdutoBem - proposta.VlrEntrada) : proposta.VlrSolicitado
      let valorTotalSolicitado = (proposta.VlrSolicitado || 0)
      if (proposta.TipoOperacaoCred === 3) { valorTotalSolicitado = (proposta.VlrProdutoBem || 0) - (proposta.VlrEntrada || 0) }
      if (th.value.ModeloCalculo === th.$aux.ModeloCalculoEnum.SAC) {
        valorSolicitado += (proposta.VlrITBI || 0) + (proposta.VlrRegistroImovel || 0) + (proposta.VlrRegistroGarantia || 0)
        valorTotalSolicitado += (proposta.VlrITBI || 0) + (proposta.VlrRegistroImovel || 0) + (proposta.VlrRegistroGarantia || 0)
      }
      valorTotalSolicitado += (proposta.VlrTAC || 0) + th.vlrRegistro

      if (proposta.OutrosServicos) { valorTotalSolicitado += (proposta.VlrSeguro || 0) + (proposta.VlrAvaliacao || 0) + (proposta.VlrVistoria || 0) }

      const computedModel = {
        Codigo: th.value.Codigo,
        Situacao: '',
        SituacaoDescricao: '',
        Cliente: {
          ...proposta.Cliente,
          DocumentoFederal: proposta.DocumentoFederal,
          Nome: proposta.Nome
        },
        CodigoCliente: null,
        CodigoSimulacao: proposta.CodigoSimulacao,

        TipoOperacaoCred: proposta.TipoOperacaoCred,
        TipoOperacaoNome: proposta.TipoOperacaoNome,
        TipoCalculoFluxo: proposta.TipoCalculoFluxo,
        TipoContratoDescricao: proposta.TipoContratoDescricao,
        PrimeiraParcela: proposta.Parcelas[0],
        UltimaParcela: proposta.Parcelas[proposta.Parcelas.length - 1],
        Prazo: proposta.Prazo,

        VlrSolicitado: valorSolicitado,
        VlrTAC: proposta.VlrTAC,
        VlrTotalSolicitado: valorTotalSolicitado,
        VlrIOF: th.mValue.TipoCalculoFluxo === th.$aux.TipoFluxoEnum.Irregular ? result.Proposta.IOF : result.Proposta.VlrIOF || result.Proposta.IOF,
        VlrTotalFinanciado: th.mValue.TipoCalculoFluxo === th.$aux.TipoFluxoEnum.Irregular ? (result.Proposta.IOF || 0) + valorTotalSolicitado + (result.VlrRegistro || 0) : (result.Proposta.VlrIOF || result.Proposta.IOF || 0) + valorTotalSolicitado,
        VlrTotalDivida: result.Proposta.VlrTotalDivida,

        OutrosServicos: proposta.OutrosServicos,
        VlrSeguro: proposta.VlrSeguro,
        VlrAvaliacao: proposta.VlrAvaliacao,
        VlrVistoria: proposta.VlrVistoria,

        PercIndiceFinan: th.value.PercIndiceFinan,
        PercJurosMensal: result.Proposta.PercJurosMensal || result.Proposta.TxJurosAoMes,
        PercJurosAnual: result.Proposta.PercJurosAnual || result.Proposta.TxJurosAoAno,
        PercCETMensal: result.Proposta.PercCETMensal || result.Proposta.CETaoMes,
        PercCETAnual: result.Proposta.PercCETAnual || result.Proposta.CETaoAno,
        ModeloCalculo: th.value.ModeloCalculo,
        TipoIndexador: th.value.TipoIndexador,
        TipoIndiceFinan: th.value.TipoIndiceFinan,

        Parcelas: proposta.Parcelas,
        GarantiaSimulacao: proposta.GarantiaSimulacao,
        VencimentoPersonalizado: proposta.VencimentoPersonalizado ?? false,
        VlrRegistroImovel: proposta.VlrRegistroImovel,
        VlrTxAdmMensal: proposta.VlrTxAdmMensal,
        VlrITBI: proposta.VlrITBI,
        VlrRegistroGarantia: proposta.VlrRegistroGarantia,
        PercSeguroMensal1: proposta.PercSeguroMensal1,
        VlrSeguroMensal1: proposta.VlrSeguroMensal1,
        PercSeguroMensal2: proposta.PercSeguroMensal2,
        VlrSeguroMensal2: proposta.VlrSeguroMensal2
      }

      th.$set(th, 'model', computedModel)
      th.$refs.resumo.load(th.model)
      th.$set(th.mValue, 'TipoCampoSeguroMIP', (proposta.PercSeguroMensal1 === null ? (proposta.VlrSeguroMensal1 === null ? null : 'R$') : '%'))
      th.$set(th.mValue, 'TipoCampoSeguroDFI', (proposta.PercSeguroMensal2 === null ? (proposta.VlrSeguroMensal2 === null ? null : 'R$') : '%'))
    }
  },
};
</script>
